import { render, staticRenderFns } from "./liquidation_simulation.vue?vue&type=template&id=4fda38f0"
import script from "./liquidation_simulation.vue?vue&type=script&lang=js"
export * from "./liquidation_simulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports